if (!customElements.get('bbk-countdown')) {
  class BbkCountdown extends HTMLElement {
    connectedCallback() {
      this.durationMs = (parseInt(this.dataset.durationMinutes, 10) || 240) * 60000;
      this.storageKey = this.dataset.storageKey || 'bbk_countdown_default';
      this.loop = this.dataset.loop !== 'false';
      this.endsAtEl = this.querySelector('[data-bbk-countdown-value]');
      this.expiredText = this.dataset.expiredText || '';
      this.init();
    }

    init() {
      let endsAt = null;
      try {
        const stored = window.localStorage.getItem(this.storageKey);
        if (stored) endsAt = parseInt(stored, 10);
      } catch (e) {
        endsAt = null;
      }

      const now = Date.now();
      if (!endsAt || endsAt <= now) {
        endsAt = now + this.durationMs;
        try {
          window.localStorage.setItem(this.storageKey, String(endsAt));
        } catch (e) {
          /* storage unavailable, timer still runs in-memory */
        }
      }

      this.endsAt = endsAt;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const remaining = this.endsAt - Date.now();

      if (remaining <= 0) {
        if (this.loop) {
          try {
            window.localStorage.removeItem(this.storageKey);
          } catch (e) {
            /* noop */
          }
          this.init();
        } else {
          clearInterval(this.timer);
          if (this.expiredText && this.endsAtEl) {
            this.endsAtEl.textContent = this.expiredText;
          } else {
            this.closest('.bbk-urgency')?.setAttribute('hidden', '');
          }
        }
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const pad = (n) => String(n).padStart(2, '0');
      const label = hours > 0 ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}` : `${pad(minutes)}:${pad(seconds)}`;

      if (this.endsAtEl) this.endsAtEl.textContent = label;
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  customElements.define('bbk-countdown', BbkCountdown);
}

if (!customElements.get('bbk-viewer-count')) {
  class BbkViewerCount extends HTMLElement {
    connectedCallback() {
      this.base = parseInt(this.dataset.baseCount, 10) || 40;
      this.valueEl = this.querySelector('[data-bbk-viewer-value]');
      this.render();
      this.timer = setInterval(() => this.render(), 4500);
    }

    render() {
      const jitter = Math.floor(Math.random() * 9) - 4;
      const value = Math.max(this.base + jitter, 1);
      if (this.valueEl) this.valueEl.textContent = value;
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  customElements.define('bbk-viewer-count', BbkViewerCount);
}
